import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export interface SavingIndicatorProps {
  className?: string;
  isSaving?: boolean;
  savingText?: string;
  savedText?: string;
  savingTimeInMs?: number;
  hideUntilSaved?: boolean;
}

export const SavingIndicator: React.FC<SavingIndicatorProps> = ({
  className,
  isSaving = false,
  savingText = "Saving...",
  savedText = "All Changes Saved",
  savingTimeInMs = 2000,
  hideUntilSaved = true,
}) => {
  const [isShowingSaving, setIsShowingSaving] = useState(false);
  const [hasBeenSaving, setHasBeenSaving] = useState(false);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    if (isSaving) {
      setIsShowingSaving(true);
      setHasBeenSaving(true);
    } else if (hasBeenSaving && isShowingSaving) {
      // Ensure spinner shows for at least savingTimeInMs
      timeout = setTimeout(() => {
        setIsShowingSaving(false);
      }, savingTimeInMs);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [isSaving, hasBeenSaving, isShowingSaving, savingTimeInMs]);

  if (hideUntilSaved && !hasBeenSaving) {
    return null;
  }

  return (
    <span className={`ucl-saving-indicator ${className || ""}`.trim()}>
      {isShowingSaving ? (
        <>
          <span className="loader ucl-saving-indicator__spinner" />
          <span className="ucl-saving-indicator__text">{savingText}</span>
        </>
      ) : (
        <>
          <FontAwesomeIcon
            icon={faCheck}
            className="ucl-saving-indicator__check"
          />
          <span className="ucl-saving-indicator__text">{savedText}</span>
        </>
      )}
    </span>
  );
};
